module.exports = __webpack_public_path__ + "static/media/44.584de462.svg";